module.exports = __webpack_public_path__ + "img/P150T_weapon_17.1b9d93a9.png";